exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".sidebar__sidebar___2iXnl {\n  box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.75);\n  background: #FFFFFF;\n  border-radius: 6px;\n  min-width: 400px;\n  max-width: 400px;\n  display: flex;\n  flex-direction: column; }\n  .sidebar__sidebar___2iXnl .sidebar__headerWrapper___2Q3vE {\n    height: 90px; }\n    .sidebar__sidebar___2iXnl .sidebar__headerWrapper___2Q3vE .sidebar__header___1oVY7 {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      height: 90px;\n      flex-direction: row;\n      padding: 0 20px;\n      flex-shrink: 0; }\n      .sidebar__sidebar___2iXnl .sidebar__headerWrapper___2Q3vE .sidebar__header___1oVY7 .sidebar__userInfo___2GiYt {\n        display: flex; }\n  .sidebar__sidebar___2iXnl .sidebar__tab___2ciw8 {\n    display: flex;\n    flex-direction: column;\n    height: 100%; }\n", ""]);

// exports
exports.locals = {
	"sidebar": "sidebar__sidebar___2iXnl",
	"headerWrapper": "sidebar__headerWrapper___2Q3vE",
	"header": "sidebar__header___1oVY7",
	"userInfo": "sidebar__userInfo___2GiYt",
	"tab": "sidebar__tab___2ciw8"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules=true&importLoaders=1&localIdentName=[name]__[local]___[hash:base64:5]!./~/sass-loader?includePaths[]=./src/styles!./src/containers/Sidebar/Main/sidebar.scss
// module id = 738
// module chunks = 0